import axios from "axios";

export const api = axios.create({
  baseURL: window.config.baseUrl,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("_bpAuth");

  if (token) {
    config.headers.Authorization = token;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      console.warn(
        "⚠️ Token inválido ou expirado — executando ação automática..."
      );

      // EXEMPLO: limpar sessão e redirecionar
      sessionStorage.clear();
      localStorage.clear();

      window.location.href = "/auth/sign-in";
    }

    return Promise.reject(error);
  }
);
